import React from "react";

const NotificationSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col w-full h-full overflow-y-hidden">
      {[1, 2, 3].map((val, index) => (
        <div className="w-full px-4 sm:px-5 mb-3" key={val}>
          <div>
            <div className="skeleton w-40 sm:w-52 min-h-6 my-2 !rounded-md"></div>
          </div>
          <div className="flex justify-start items-center gap-2 sm:gap-3 w-full">
            <div className="skeleton w-24 sm:w-32 min-h-20 !rounded-md"></div>
            <div className="flex flex-col gap-1 sm:gap-2 w-[calc(100%-112px)] sm:w-[calc(100%-144px)]">
              <div className="skeleton w-20 sm:w-24 min-h-5 !rounded-md"></div>
              <div className="skeleton w-36 sm:w-48 min-h-5 !rounded-md"></div>
              <div className="skeleton w-24 sm:w-28 min-h-5 !rounded-md"></div>
            </div>
          </div>
          {index !== 2 && (
            <div className="w-full h-3 sm:h-4 mt-3 sm:mt-4 bg-contain bg-no-repeat bg-[url('@assets/images/cartsummaryBorder.webp')]"></div>
          )}
        </div>
      ))}
    </div>
  );
};

export default NotificationSkeleton;
